export enum FormFieldsTypes {
    Email = 'email',
    Password = 'password',
}

export enum SignInInputTypes {
    Input= 'input',
    Password= 'password'
}

export interface ISignInFields {
    [FormFieldsTypes.Email]: string;
    [FormFieldsTypes.Password]: string;
}

export const SIGNIN_FORM_INITIAL_STATE: ISignInFields = {
    [FormFieldsTypes.Email]: '',
    [FormFieldsTypes.Password]: '',
};

export interface ISignInRequestData {
    [FormFieldsTypes.Email]: string;
    [FormFieldsTypes.Password]: string;
}
